module.exports = __webpack_public_path__ + "img/Logo.08085848.png";